import { ErrorDialog } from "@codat/orchard-ui";
import React from "react";

export const NotFound: React.FC = () => {
  return <ErrorDialog statusCode={404} />;
};
